export default class ApiClient {
    private readonly basePath: string;
    private jq: JQueryStatic;

    constructor(basePath: string, jQuery: JQueryStatic) {
        this.basePath = basePath;
        this.jq = jQuery;
    }

    public markNotificationAsRead(notificationId: number): JQuery.jqXHR {
        const url = this.basePath + "Notification/MarkAsRead";
        const data = {idList: notificationId};

        return this.doRequest(url, HttpMethods.POST, data);
    }

    public markAllNotificationsAsRead(notificationIds: number[]): JQuery.jqXHR {
        const url = this.basePath + "Notification/MarkAllAsRead";
        const data = {idList: notificationIds};

        return this.doRequest(url, HttpMethods.POST, data);
    }

    public dismissNotification(notificationId: number): JQuery.jqXHR {
        const url = this.basePath + "Notification/MarkNotificationDismissed";
        const data = {id: notificationId};

        return this.doRequest(url, HttpMethods.POST, data);
    }

    public dismissAllNotifications(notificationIds: number[]): JQuery.jqXHR {
        const url = this.basePath + "Notification/MarkAllNotificationsDismissed";
        const data = {idList: notificationIds};

        return this.doRequest(url, HttpMethods.POST, data);
    }

    private doRequest<T>(url: string, method: HttpMethods, data?: string | JQuery.PlainObject): JQuery.jqXHR<T> {
        const ajaxSettings: JQueryAjaxSettings = {
            url,
            data,
            method,
        };

        return this.jq.ajax(ajaxSettings);
    }
}

enum HttpMethods {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    PATCH = "PATCH",
    DELETE = "DELETE",
}
